import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { clearAllNfts } from "../../API/functions";
import { clearCart } from "../../redux/slices/CartSlice";
import { useDispatch } from "react-redux";


export const useClearAllNfts = () => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient();
  const { mutate, data, isPending, error } = useMutation({
    mutationFn: (vars) => clearAllNfts(vars),
    onSuccess: (result) => {
      dispatch(clearCart());
      queryClient.invalidateQueries(["cartNft"]);
      toast.success(result.message);
    },
    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { mutate, data, isPending, error };
};


